import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { A1Page } from './pages/A1Page';
import { Adv1Page } from './pages/Adv1Page';
import { Adv2Page } from './pages/Adv2Page';
import { Adv3Page } from './pages/Adv3Page';
import { GlpAdv1Page } from './pages/GlpAdv1Page';
import { GlpAdv2Page } from './pages/GlpAdv2Page';
import { GlpAdv3Page } from './pages/GlpAdv3Page';
import { GlpAdv4Page } from './pages/GlpAdv4Page';
import { GlpAdv5Page } from './pages/GlpAdv5Page';
import { GlpAdv6Page } from './pages/GlpAdv6Page';
import { Glp6TipsPage } from './pages/Glp6TipsPage';
import { GlpPlateau1Page } from './pages/GlpPlateau1Page';
import { Rlt1Page } from './pages/Rlt1Page';
import { Rlt2Page } from './pages/Rlt2Page';
export function AppRouter() {
  return <BrowserRouter data-id="element-20">
      <Routes data-id="element-21">
        <Route path="/" element={<App data-id="element-23" />} data-id="element-22" />
        <Route path="/-a-1" element={<A1Page data-id="element-25" />} data-id="element-24" />
        <Route path="/adv-1" element={<Adv1Page data-id="element-27" />} data-id="element-26" />
        <Route path="/glp1-investigation" element={<Adv2Page data-id="element-29" />} data-id="element-28" />
        <Route path="/glp-adv-1" element={<GlpAdv1Page data-id="element-31" />} data-id="element-30" />
        <Route path="/glp-adv-2" element={<GlpAdv2Page data-id="element-33" />} data-id="element-32" />
        <Route path="/glp-adv-3" element={<GlpAdv3Page data-id="element-35" />} data-id="element-34" />
        <Route path="/glp-adv-4" element={<GlpAdv4Page data-id="element-37" />} data-id="element-36" />
        <Route path="/glp-adv-5" element={<GlpAdv5Page data-id="element-39" />} data-id="element-38" />
        <Route path="/glp-adv-6" element={<GlpAdv6Page data-id="element-41" />} data-id="element-40" />
        <Route path="/glp-6-tips" element={<Glp6TipsPage data-id="element-43" />} data-id="element-42" />
        <Route path="/glp-plateau-1" element={<GlpPlateau1Page data-id="element-45" />} data-id="element-44" />
        <Route path="/rlt-1" element={<Rlt1Page data-id="element-47" />} data-id="element-46" />
        <Route path="/rlt-2" element={<Rlt2Page data-id="element-49" />} data-id="element-48" />
        <Route path="/adv-3" element={<Adv3Page data-id="element-51" />} data-id="element-50" />
      </Routes>
    </BrowserRouter>;
}